<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
      <router-view />
  </v-app>

</template>

<script>
import firebase from "firebase";
export default {
  name: 'App',
  beforeCreate(){
    firebase.auth().onAuthStateChanged((user) => {
      console.log('Data login: ', user);
      if(this.$route.fullPath != '/login'){
        if (!user) {
          this.$router.replace("/login")
        }
      }else{
        if(user){
          this.$router.replace("/");
        }
      }
    });
  },
  components: {
    
  }

};
</script>
